import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'

const ActionButton = () => {
    const [isActive, setIsActive] = useState(true);

    const handleActive = () => {
        confirmAlert({
            message: "Are you sure you want to change the status?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => setIsActive(!isActive)
                },


                {
                    label: 'Cancel',
                    onClick: () => setIsActive(true)
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        });
    };

    const handleInactive = () => {
        confirmAlert({
            message: "Are you sure you want to change the status?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => setIsActive(!isActive)
                },
                {
                    label: 'Cancel',
                    onClick: () => setIsActive(false)
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        });
    };

    return (
        <>
            {isActive ? <button className='bg-[#30c381] h-7 w-16 xsm:w-20 text-center leading-7 text-white text-xs xsm:text-sm font-medium rounded-sm cursor-pointer hover:bg-[#21af6f] animation' onClick={handleActive} >
                <i className="fa-regular fa-circle-check mr-[2px]"></i>
                Active
            </button> : <button className='bg-[#eba610] h-7 w-16 xsm:w-20 text-center leading-7 text-white text-xs xsm:text-sm font-medium rounded-sm cursor-pointer hover:bg-[#e2b41c] animation' onClick={handleInactive}>
                <i className=" fa-regular fa-circle-xmark mr-[2px]"></i>
                Inactive
            </button>}
        </>
    )
}

export default ActionButton;
